/**
 * True when the app is running inside an iframe (the embedded editor) rather
 * than as the top-level window.
 *
 * Extracted to a standalone leaf so eager, non-editor modules (designs actions,
 * downloads, portal util, etc.) can read this predicate without importing
 * views/components/Editor/utils — which drags the CanvasBackground component and
 * the font/SVG loaders into the eager entry chunk.
 */
export const isEditorInIframe = (): boolean => window.parent !== window;
